// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BF Code Labs - Custom Styles */

.nav-link {
    position: relative;
    color: var(--text-secondary);
    transition: color 0.3s ease;
}

.nav-link:hover {
    color: var(--accent-primary);
}

.nav-link::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 2px;
    background: linear-gradient(90deg, var(--accent-primary), var(--accent-secondary));
    transition: width 0.3s ease;
}

.nav-link:hover::after,
.nav-link.active::after {
    width: 100%;
}

.nav-link.active {
    color: var(--accent-primary);
}

/* Hero section */
.hero-bg {
    background: 
        radial-gradient(ellipse at 20% 20%, rgba(0, 212, 170, 0.08) 0%, transparent 50%),
        radial-gradient(ellipse at 80% 80%, rgba(14, 165, 233, 0.08) 0%, transparent 50%),
        var(--bg-primary);
}

/* Service card */
.service-card {
    background: var(--bg-card);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    padding: 2rem;
    transition: all 0.3s ease;
}

.service-card:hover {
    border-color: var(--accent-primary);
    transform: translateY(-8px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 212, 170, 0.1);
}

.service-icon {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(0, 212, 170, 0.1), rgba(14, 165, 233, 0.1));
    border: 1px solid var(--border-color);
    margin-bottom: 1.5rem;
}

/* Button styles */
.btn-primary {
    background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
    color: var(--bg-primary);
    font-weight: 600;
    padding: 0.75rem 2rem;
    border-radius: 8px;
    transition: all 0.3s ease;
    border: none;
    cursor: pointer;
}

.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(0, 212, 170, 0.3);
}

.btn-secondary {
    background: transparent;
    color: var(--accent-primary);
    font-weight: 600;
    padding: 0.75rem 2rem;
    border-radius: 8px;
    border: 1px solid var(--accent-primary);
    transition: all 0.3s ease;
    cursor: pointer;
}

.btn-secondary:hover {
    background: rgba(0, 212, 170, 0.1);
    transform: translateY(-2px);
}

/* Contact form */
.form-input {
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    padding: 0.875rem 1rem;
    color: var(--text-primary);
    width: 100%;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.form-input:focus {
    outline: none;
    border-color: var(--accent-primary);
    box-shadow: 0 0 0 3px rgba(0, 212, 170, 0.1);
}

.form-input::placeholder {
    color: var(--text-secondary);
}

/* Footer */
.footer-link {
    color: var(--text-secondary);
    transition: color 0.3s ease;
}

.footer-link:hover {
    color: var(--accent-primary);
}

/* Code decoration */
.code-decoration {
    position: absolute;
    font-family: 'JetBrains Mono', monospace;
    font-size: 0.75rem;
    color: var(--text-secondary);
    opacity: 0.3;
    pointer-events: none;
}

/* Grid pattern background */
.grid-pattern {
    background-image: 
        linear-gradient(rgba(42, 42, 58, 0.3) 1px, transparent 1px),
        linear-gradient(90deg, rgba(42, 42, 58, 0.3) 1px, transparent 1px);
    background-size: 50px 50px;
}

/* Tech stack badges */
.tech-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: 20px;
    font-size: 0.875rem;
    color: var(--text-secondary);
    transition: all 0.3s ease;
}

.tech-badge:hover {
    border-color: var(--accent-primary);
    color: var(--accent-primary);
}

/* Stats counter */
.stat-number {
    font-family: 'JetBrains Mono', monospace;
    font-size: 3rem;
    font-weight: 700;
    background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* Mobile menu */
.mobile-menu {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    max-width: 300px;
    height: 100vh;
    background: var(--bg-card);
    border-left: 1px solid var(--border-color);
    transform: translateX(100%);
    transition: transform 0.3s ease;
    z-index: 50;
}

.mobile-menu.open {
    transform: translateX(0);
}

/* Page transition */
.page-enter {
    opacity: 0;
    transform: translateY(20px);
}

.page-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 0.3s ease, transform 0.3s ease;
}

/* Skeleton loading */
.skeleton {
    background: linear-gradient(90deg, var(--bg-secondary) 25%, var(--bg-card) 50%, var(--bg-secondary) 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
}

@keyframes skeleton-loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,WAAW;IACX,kFAAkF;IAClF,2BAA2B;AAC/B;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC;;AAEA,iBAAiB;AACjB;IACI;;;yBAGqB;AACzB;;AAEA,iBAAiB;AACjB;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,2EAA2E;AAC/E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oFAAoF;IACpF,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,mFAAmF;IACnF,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,uCAAuC;IACvC,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA,iBAAiB;AACjB;IACI,+BAA+B;IAC/B,qCAAqC;IACrC,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,WAAW;IACX,wDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,4CAA4C;AAChD;;AAEA;IACI,4BAA4B;AAChC;;AAEA,WAAW;AACX;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;IACZ,oBAAoB;AACxB;;AAEA,4BAA4B;AAC5B;IACI;;0EAEsE;IACtE,0BAA0B;AAC9B;;AAEA,sBAAsB;AACtB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,+BAA+B;IAC/B,qCAAqC;IACrC,mBAAmB;IACnB,mBAAmB;IACnB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,4BAA4B;AAChC;;AAEA,kBAAkB;AAClB;IACI,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,mFAAmF;IACnF,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,0CAA0C;IAC1C,2BAA2B;IAC3B,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,oBAAoB;AACpB;IACI,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,kDAAkD;AACtD;;AAEA,qBAAqB;AACrB;IACI,wGAAwG;IACxG,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,KAAK,2BAA2B,EAAE;IAClC,OAAO,4BAA4B,EAAE;AACzC","sourcesContent":["/* BF Code Labs - Custom Styles */\n\n.nav-link {\n    position: relative;\n    color: var(--text-secondary);\n    transition: color 0.3s ease;\n}\n\n.nav-link:hover {\n    color: var(--accent-primary);\n}\n\n.nav-link::after {\n    content: '';\n    position: absolute;\n    bottom: -4px;\n    left: 0;\n    width: 0;\n    height: 2px;\n    background: linear-gradient(90deg, var(--accent-primary), var(--accent-secondary));\n    transition: width 0.3s ease;\n}\n\n.nav-link:hover::after,\n.nav-link.active::after {\n    width: 100%;\n}\n\n.nav-link.active {\n    color: var(--accent-primary);\n}\n\n/* Hero section */\n.hero-bg {\n    background: \n        radial-gradient(ellipse at 20% 20%, rgba(0, 212, 170, 0.08) 0%, transparent 50%),\n        radial-gradient(ellipse at 80% 80%, rgba(14, 165, 233, 0.08) 0%, transparent 50%),\n        var(--bg-primary);\n}\n\n/* Service card */\n.service-card {\n    background: var(--bg-card);\n    border: 1px solid var(--border-color);\n    border-radius: 12px;\n    padding: 2rem;\n    transition: all 0.3s ease;\n}\n\n.service-card:hover {\n    border-color: var(--accent-primary);\n    transform: translateY(-8px);\n    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 212, 170, 0.1);\n}\n\n.service-icon {\n    width: 60px;\n    height: 60px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, rgba(0, 212, 170, 0.1), rgba(14, 165, 233, 0.1));\n    border: 1px solid var(--border-color);\n    margin-bottom: 1.5rem;\n}\n\n/* Button styles */\n.btn-primary {\n    background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\n    color: var(--bg-primary);\n    font-weight: 600;\n    padding: 0.75rem 2rem;\n    border-radius: 8px;\n    transition: all 0.3s ease;\n    border: none;\n    cursor: pointer;\n}\n\n.btn-primary:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 30px rgba(0, 212, 170, 0.3);\n}\n\n.btn-secondary {\n    background: transparent;\n    color: var(--accent-primary);\n    font-weight: 600;\n    padding: 0.75rem 2rem;\n    border-radius: 8px;\n    border: 1px solid var(--accent-primary);\n    transition: all 0.3s ease;\n    cursor: pointer;\n}\n\n.btn-secondary:hover {\n    background: rgba(0, 212, 170, 0.1);\n    transform: translateY(-2px);\n}\n\n/* Contact form */\n.form-input {\n    background: var(--bg-secondary);\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    padding: 0.875rem 1rem;\n    color: var(--text-primary);\n    width: 100%;\n    transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.form-input:focus {\n    outline: none;\n    border-color: var(--accent-primary);\n    box-shadow: 0 0 0 3px rgba(0, 212, 170, 0.1);\n}\n\n.form-input::placeholder {\n    color: var(--text-secondary);\n}\n\n/* Footer */\n.footer-link {\n    color: var(--text-secondary);\n    transition: color 0.3s ease;\n}\n\n.footer-link:hover {\n    color: var(--accent-primary);\n}\n\n/* Code decoration */\n.code-decoration {\n    position: absolute;\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 0.75rem;\n    color: var(--text-secondary);\n    opacity: 0.3;\n    pointer-events: none;\n}\n\n/* Grid pattern background */\n.grid-pattern {\n    background-image: \n        linear-gradient(rgba(42, 42, 58, 0.3) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(42, 42, 58, 0.3) 1px, transparent 1px);\n    background-size: 50px 50px;\n}\n\n/* Tech stack badges */\n.tech-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1rem;\n    background: var(--bg-secondary);\n    border: 1px solid var(--border-color);\n    border-radius: 20px;\n    font-size: 0.875rem;\n    color: var(--text-secondary);\n    transition: all 0.3s ease;\n}\n\n.tech-badge:hover {\n    border-color: var(--accent-primary);\n    color: var(--accent-primary);\n}\n\n/* Stats counter */\n.stat-number {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 3rem;\n    font-weight: 700;\n    background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n/* Mobile menu */\n.mobile-menu {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 100%;\n    max-width: 300px;\n    height: 100vh;\n    background: var(--bg-card);\n    border-left: 1px solid var(--border-color);\n    transform: translateX(100%);\n    transition: transform 0.3s ease;\n    z-index: 50;\n}\n\n.mobile-menu.open {\n    transform: translateX(0);\n}\n\n/* Page transition */\n.page-enter {\n    opacity: 0;\n    transform: translateY(20px);\n}\n\n.page-enter-active {\n    opacity: 1;\n    transform: translateY(0);\n    transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n/* Skeleton loading */\n.skeleton {\n    background: linear-gradient(90deg, var(--bg-secondary) 25%, var(--bg-card) 50%, var(--bg-secondary) 75%);\n    background-size: 200% 100%;\n    animation: skeleton-loading 1.5s infinite;\n}\n\n@keyframes skeleton-loading {\n    0% { background-position: 200% 0; }\n    100% { background-position: -200% 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
